module.exports = __webpack_public_path__ + "static/img/ios_en.6cea0f25.png";